module.exports = __webpack_public_path__ + "static/img/scmbanner4.d9df743.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scmbanner4.png
// module id = HOeV
// module chunks = 1